// extracted by mini-css-extract-plugin
export default {"homeLayout":"Home_homeLayout__ZrwZB","title":"Home_title__ANWNn","suggestions":"Home_suggestions__SoNKs"};